<template>
  <basic-portlet title="Change Password" icon="flaticon2-lock" :bordered="true">
    <div class="row">
      <div class="col-12">
        <div class="form-group kt-form__group">
          <div v-if="!admin" class="input-container">
            <div class="input-group kt-input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"><i
                  class="la la-lock" /></span>
              </div>
              <input v-model="password_current" v-validate="'required'"
                     data-vv-as="current password" type="password"
                     name="password_current kt-input" class="form-control"
                     placeholder="Current Password" autocomplete="off"
                     aria-describedby="basic-addon1">
            </div>
            <transition name="fade">
              <p v-show="errors.has('password')" class="help is-danger">
                {{ errors.first('password_current') }}
              </p>
            </transition>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group kt-form__group">
          <div class="input-container">
            <div class="input-group kt-input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"><i
                  class="la la-lock" /></span>
              </div>
              <input ref="password" v-model="password"
                     v-validate.continues="'required|min:8|has_lc_alpha|has_uc_alpha|has_digit|has_special'" type="password"
                     name="password"
                     class="form-control kt-input"
                     placeholder="Password" autocomplete="off"
                     aria-describedby="basic-addon1">
            </div>
            <transition name="fade">
              <ul v-show="errors.has('password')" class="help is-danger">
                <li v-for="(err, index) in errors.collect(`password`)" :key="index">
                  {{ err }}
                </li>
              </ul>
            </transition>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group kt-form__group">
          <div class="input-container">
            <div class="input-group kt-input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"><i
                  class="la la-lock" /></span>
              </div>
              <input ref="password_confirmation"
                     v-model="password_confirmation"
                     v-validate.continues="'required|confirmed:password'"
                     data-vv-as="password confirmation"
                     type="password" name="password_confirmation"
                     class="form-control kt-input" placeholder="Confirm Password"
                     autocomplete="off" aria-describedby="basic-addon1">
            </div>
            <transition name="fade">
              <p v-show="errors.has('password_confirmation')"
                 class="help is-danger">
                {{ errors.first('password_confirmation') }}
              </p>
            </transition>
          </div>
        </div>
      </div>
      <div class="col-12">
        <button class="btn btn-ss-standout"
                :class="{
                  'disabled': !all_good,
                }"
                @click.prevent="changePassword">
          <i class="fa fa-save" />&nbsp;Save Changes
        </button>
      </div>
    </div>
  </basic-portlet>
</template>

<script>
import BasicPortlet from "VueComponents/BasicPortlet";
export default {
  name: "ChangePassword",
  components: { BasicPortlet },
  props: {
    sidebar: {
      type: Boolean,
      required: false,
    },
    admin: {
      type: Boolean,
      required: false,

    },
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    password_current: null,
    password_confirmation: null,
    password: null,
    formIncomplete: false,
  }),
  computed: {
    all_good() {
      // not using validateAll as it returns a Promise
      // using asyncComputed will cause the validator to run on load, and we
      // only want validation errors to show up when the user is interacting with
      // the form
      return ([
        ...this.errors.collect(`password`),
        ...this.errors.collect(`password_confirmation`),
      ].length === 0 && this.password && this.password_confirmation);
    },
  },
  methods: {
    async changePassword() {
      const form_data = {
        password_current: this.password_current,
        password: this.password,
        password_confirmation: this.password_confirmation,
        admin: this.admin,
      };

      const result = await this.$validator.validateAll();
      if (result) {
        axios
          .post(`/user/${window.user.uuid}/changePassword`, form_data)
          .then(() => {
            toastr.success("Password Changed");
            this.password_current = null;
            this.password = null;
            this.password_confirmation = null;
            this.errors.clear();
          })
          .catch((error) => {
            window.handleAxiosError(error);
          });
      } else {
        toastr.error("Some fields have not been completed correctly");
      }
    },
  },
};
</script>

<style scoped lang='scss'>
input.has-error {
    border: 1px solid #e73d4a;
}

.input-container {
    margin-bottom: 10px;
}

p.is-danger,
ul.is-danger {
    margin-top: 5px;
    color: #e73d4a;
}
</style>
